'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _actions.SET_SNACKBAR:
      return action.payload;
    case _actions.SET_MESSAGE:
      return (0, _util.merge)(state, {
        message: action.payload
      });
    default:
      return state;
  }
};

var _actions = require('./actions');

var _util = require('@its/util');

var initialState = {
  snackBar: {
    message: '',
    show: false,
    initiallyOpen: false
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/SnackBarContainer/reducer.js
 ** module id = 478
 ** module chunks = 0
 **/